export default __webpack_public_path__ + "locales/nl/Translations.json?hash=c55a916cc330a74cffa8b15ef434079e";